import React from 'react';
import { observer } from 'mobx-react-lite';
import { DescriptionContainer } from '../../../pages/caseView/description/Description.styled';
import { ZeroStage } from '../../../pages/caseView/description/stages/common/zeroStage/ZeroStage';
import { FirstStage as FirstStageCushingV2 } from '../../../pages/caseView/description/stages/cushingV2/firstStage/FirstStage';
import { SecondStage as SecondStageCushingV2 } from '../../../pages/caseView/description/stages/cushingV2/secondStage/SecondStage';
import { ThirdStage as ThirdStageCushingV2 } from '../../../pages/caseView/description/stages/cushingV2/thirdStage/ThirdStage';
import { FourthStage } from '../../../pages/caseView/description/stages/common/fourthStage/FourthStage';

export const CushingV2PdfContent: React.FC = observer(() => {
  // Page margins live here (inside the captured [data-pdf-id]) — symmetric and smaller than
  // the old 24px so PDF content is wider / closer to the live view wrap (RR-603).
  return (
    <DescriptionContainer style={{ padding: '16px 20px' }}>
      <ZeroStage />
      <FirstStageCushingV2 />
      <SecondStageCushingV2 />
      <ThirdStageCushingV2 />
      <FourthStage />
    </DescriptionContainer>
  );
});
